/**
 *  AppShell script file
**/

export default {
  name: 'AppShell',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {
  },
  methods: {
  }
}
